const Reg = {
    // 完成日期(有的日期格式返回错误，日和时间中间没有间隔)
    simpleTime: /^\d{4}[\/-]\d{2}[\/-]\d{2}(\s?(\d{2}:)?(\d{2}:)?\d{2})?$/
}

export function isNothing(str) {
    if (str === null || str === undefined || str === '') return true;
}

export function isSimpleTime(str) {
    return Reg.simpleTime.test(str)
}

export function getYMD(str) {
    if (isNothing(str)) {
        return ''
    } else if (isSimpleTime(str)) {
        return str.slice(0,10)
    }
    return str
}

// 格式数字-千分位
export function getThousand (str) {
    str = str.toString();
    if (str.indexOf(".") > -1) {
        let tempArr = str.split(".");
        let leftStr = tempArr[0];
        let rightStr = tempArr[1];
        let result = "";

        while (leftStr.length > 3) {
            result = "," + leftStr.slice(-3) + result;
            leftStr = leftStr.slice(0, leftStr.length - 3);
        }
        if (leftStr) {
            result = leftStr + result;
        }
        return result + "." + rightStr;
    } else {
        let result = "";

        while (str.length > 3) {
            result = "," + str.slice(-3) + result;
            str = str.slice(0, str.length - 3);
        }
        if (str) {
            result = str + result;
        }
        return result;
    }
};

// 防抖请求
export function debounce (func, wait, immediate) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        const callNow = !timeout;
        timeout = setTimeout(function () {
          timeout = null;
        }, wait)
        if (callNow) func.apply(context, args)
      } else {
        timeout = setTimeout(function () {
          func.apply(context, args)
        }, wait);
      }
    }
  }

// 节流
export function throttle(func, wait) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        if (!timeout) {
            timeout = setTimeout(function () {
                timeout = null;
                func.apply(context, args)
            }, wait)
        }

    }
}
